// deps
import React, { memo, ReactElement } from "react";

// internal-deps
import { isEmpty } from "@swiggy-private/payment-core";

// widgets
import { PaymentMethodIcon } from "@payment-ui/widgets/payment-method-icon";

// constants
import { META_POINT_ICON_WIDTH } from "@payment-ui/constants/PayLater";

// helpers
import { getPayLaterMetaPoints } from "@payment-ui/helpers/PayLater";
import { getIconCloudinaryUrl as getCloudinaryUrl } from "@payment-ui/helpers/Icon";

// interfaces
import { PayLaterLinkedData } from "@payment-ui/interfaces";
import styles from "../PayLater.v4.scss";

interface MetaPointsProps {
    meta: PayLaterLinkedData;
    dataTestId?: string;
}

export const MetaPoints = memo(function PayLaterMetaPoints(props: MetaPointsProps): ReactElement | null {
    const metaPoints = getPayLaterMetaPoints(props.meta);
    if (isEmpty(metaPoints)) {
        return null;
    }

    return (
        <div>
            {metaPoints.map((point, index) => (
                <div className={styles.dialogContentPoint} key={index} data-testid={props.dataTestId}>
                    <PaymentMethodIcon
                        parentClassName={styles.dialogContentPointIconWrapper}
                        imgClassName={styles.dialogContentPointIcon}
                        src={getCloudinaryUrl(point.iconUrl ?? "")}
                        width={META_POINT_ICON_WIDTH}
                    />
                    <div className={styles.dialogContentPointText}>{point.text}</div>
                </div>
            ))}
        </div>
    );
});
